import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { filterTableDataAPI } from "../../services/CRUDServices";

export const filterSurvey: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "survey",
  async (body: any) => {
    let { data } = await filterTableDataAPI(
      "/customer-api/survey/v1/s1/grid",
      body.pageNumber,
      {
        ...body,
        pageNumber: undefined,
        pageSize: undefined,
      },
      true,
      10,
      false
    );

  
    return { data:data.response };
  }
);

const initialState: any = {
  surveyData: [],
  fetchpost: false,
  errorMessage: null,
  filter: {},
};

const SurveySlice = createSlice({
  initialState: initialState,
  name: "survey",
  reducers: {

    // clearGroupPayment: (state) => {
    //   state.deliveryList = [];
    // },
     changeSurveySwitch: (state: any, { payload }) => {
      const filterSwitch = state.surveyData.content?.find(
        (item: any) => item?.id === payload
      );
      if (filterSwitch) {
        filterSwitch.isActive = !filterSwitch.isActive;
      }
    },
    setFilterSurvey: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: {
    [filterSurvey.fulfilled as any]: (state, action) => {
      state.surveyData = action.payload.data;
      state.fetchpost = false;
    },
    [filterSurvey.pending as any]: (state) => {
      state.fetchpost = true;
    },
    [filterSurvey.rejected as any]: (state) => {
      state.fetchpost = false;
      state.errorMessage = "wrong";
    },
  },
});

export const {  setFilterSurvey,changeSurveySwitch } = SurveySlice.actions;
export default SurveySlice.reducer;
